<template>
  <div class="card-header" :class="cardHeader">
    <div class="d-flex align-items-center ps-3">
      <button 
        v-if="useBackBtn"
        class="btn btn-link text-decoration-none my-2 p-0 ps-2 pe-3"
        @click="handleBack"
      >
        <span class="fs-4 text-secondary">‹</span>
      </button>
      <div v-else class="my-2 p-0 pe-3"></div>
      <h6 class="my-2" style="font-weight: 800;">
        {{ headerTitle }}
      </h6>
    </div>
  </div>
</template>

<script>
export default {
  name: "DetailHeader",
  props: {
    cardHeader: { type: String, default: "pb-0" },
    headerTitle: { type: String, default: "" },
    useBackBtn: { type: Boolean, default: true },
    backTo: { type: [String, Object], default: null },
  },
  methods: {
    handleBack() {
      if (this.backTo) {
        this.$router.push({ name: this.backTo, query: { ...this.$route.query } });
      } else {
        this.$router.back();
      }
    }
  }
}
</script>